import {
  ApprovalStatusButton,
  Pagination,
  Table,
  TBody,
  Td,
  TdFixed,
  Th,
  THead,
  ThFixed,
  Tr
} from "components"
import {
  ButtonDetail,
  DataStatus
} from "components2"
import { ButtonGroup, OverlayTrigger, Tooltip } from "react-bootstrap"
import { dateConvert, tableNumber } from "utilities2"
import { ApprovalStatusConst } from "../const/ApprovalStatusConst"

export const ListPermintaanPerubahanData = ({
  pagination,
  getPermintaanPerubahanDataList,
  onDetailButtonClickHandler,
  onUpdateButtonClickHandler,
  onPaginationChange,
  onPaginationDataLengthChange
}) => {
  return (
    <>
      <div className="mt-2">
        <small className="font-weight-bold">
          List Data Permintaan Perubahan Data
        </small>
      </div>

      <Table>
        <THead>
          <Tr>
            <ThFixed> No. </ThFixed>
            <ThFixed> Aksi </ThFixed>
            <ThFixed> Informasi Permintaan Perubahan Data </ThFixed>
            <Th width={100}> Urgensi </Th>
            <Th width={550}> Deskripsi </Th>
            <Th width={20}> Status </Th>
          </Tr>
        </THead>

        <TBody>
          {getPermintaanPerubahanDataList?.data?.data?.length > 0 ? (
            getPermintaanPerubahanDataList?.data?.data?.map((e, index) => (
              <Tr key={index}>
                <TdFixed className="text-center">
                  {tableNumber({
                    pageCurrent: pagination.page,
                    dataLength: pagination.per_page,
                    index
                  })}
                </TdFixed>
                <TdFixed>
                  <ButtonGroup>
                    <ButtonDetail
                      icon
                      noText
                      variant="primary"
                      onClick={() => onDetailButtonClickHandler(e)}
                    />
                  </ButtonGroup>
                </TdFixed>
                <Td>
                  <div>
                    {dateConvert().getSlashDMY(
                      new Date(e.tgl_permintaan_perubahan_data_master)
                    )}
                  </div>
                  <div>{e.no_permintaan_perubahan_data_master ?? "-"}</div>
                </Td>
                <Td>{e.urgensi ?? "-"}</Td>
                <Td>
                  <div dangerouslySetInnerHTML={{ __html: e.deskripsi }}></div>
                </Td>
                <Td>
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 500, hide: 500 }}
                    trigger={["hover", "focus", "click"]}
                    overlay={
                      <Tooltip id={`tooltip-status-${index}`}>
                        {ApprovalStatusConst[e?.status]?.tooltip}
                      </Tooltip>
                    }
                  >
                    <span className="btn-block">
                      <ApprovalStatusButton
                        variant={ApprovalStatusConst[e?.status]?.variant}
                        children={ApprovalStatusConst[e?.status]?.label}
                      />
                    </span>
                  </OverlayTrigger>
                </Td>
              </Tr>
            ))
          ) : (
            <Tr>
              <Td colSpan={11}>
                <DataStatus text="Tidak ada data" />
              </Td>
            </Tr>
          )}
        </TBody>
      </Table>

      {getPermintaanPerubahanDataList.data?.data?.length ? (
        <Pagination
          dataLength={pagination?.per_page}
          dataNumber={
            pagination?.page * pagination?.per_page - pagination?.per_page + 1
          }
          dataPage={
            pagination?.dataCount < pagination?.per_page
              ? pagination?.dataCount
              : pagination?.page * pagination?.per_page
          }
          dataCount={getPermintaanPerubahanDataList?.data?.data_count}
          currentPage={pagination?.page}
          totalPage={getPermintaanPerubahanDataList?.data?.total_page}
          onPaginationChange={onPaginationChange}
          onDataLengthChange={onPaginationDataLengthChange}
        />
      ) : null}

    </>
  )
}